import { ReqX, ZCache } from "IZOX/STATIC";
import _ from "lodash";

class WebSettings {

  static GetInfo = async () => {
    let info = await ZCache.GetAsync("webInfo", async () => {
      let res = await ReqX.SendBE("/Web/PublicWebSettings/GetInfo", {}, null, null);
      let {Success, payload} = res;
      if(!Success) return;
      let rtn = {};
      _.map(payload, o => {
        rtn[o._id] = o.data;
      });
      return rtn;
    }, 3, "hours");
    return info;
  }

}

export default WebSettings;